
import type {
	SketchEntityReferenceTargetChange,
	SketchEntityReferencePropagationContext,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferencePropagation';

export type {
	SketchEntityReferenceTargetChange,
	SketchEntityReferencePropagationContext,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferencePropagation';

/** 引用目标被重建后发布给草图定义提交事件的原因。 */
export const REFERENCE_TARGET_REBUILT_COMMIT_REASON = 'reference-target-rebuilt';

/** 引用目标被创建后发布给草图定义提交事件的原因。 */
export const REFERENCE_TARGET_CREATED_COMMIT_REASON = 'reference-target-created';
